import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

const Home = () => import('@/views/Home');
const Skills = () => import('@/views/Skills');
const References = () => import('@/views/References');
const CuricVitae = () => import('@/views/CuricVitae');
const Contact = () => import('@/views/Contact');

Vue.use(Router);

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      component: DefaultContainer,
      redirect: '/o-mne',
      meta: {
        label: 'place.home'
      },
      children: [
        {
          path: '/o-mne',
          name: 'Home',
          component: Home,
        },
        {
          path: '/zkusenosti',
          name: 'Skills',
          component: Skills,
        },
        {
          path: '/reference',
          name: 'References',
          component: References,
        },
        {
          path: '/zivotopis',
          name: 'CuricVitae',
          component: CuricVitae,
        },
        {
          path: '/kontakt',
          name: 'Contact',
          component: Contact,
        },
      ]
    }
  ]
});

export default router
